import apiClient from './api';

export const formService = {
  getFormsAdmin: async () => {
    const res = await apiClient.get('/forms');
    return res.data;
  },
  createForm: async (payload) => {
    const res = await apiClient.post('/forms', payload);
    return res.data;
  },
  updateForm: async (id, payload) => {
    const res = await apiClient.put(`/forms/${id}`, payload);
    return res.data;
  },
  deleteForm: async (id) => {
    const res = await apiClient.delete(`/forms/${id}`);
    return res.data;
  },
  getForm: async (id) => {
    const res = await apiClient.get(`/forms/${id}`);
    return res.data;
  },
  submitResponse: async (id, payload) => {
    const res = await apiClient.post(`/forms/${id}/submit`, payload);
    return res.data;
  },
  getResponsesAdmin: async () => {
    const res = await apiClient.get('/forms/responses');
    return res.data;
  }
};

export default formService;
